// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3x758","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__29tdC"};